// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"LabelWithStarIcon-module_wrapper_de232","skillsIcon":"LabelWithStarIcon-module_skillsIcon_ecd08"};